import React from "react";
import { bp } from "../slug";
import { Link } from "react-router-dom";

type Src = { doc: string; clause: number | null; title?: string } | null | undefined;

/* A date or amount that jumps to the clause it came from. Plain text when nothing points back. */
export function Jump({ pid, source, children, testid }: { pid: string; source: Src; children: React.ReactNode; testid?: string }) {
  if (!source?.doc) return <>{children}</>;
  const q = `?doc=${encodeURIComponent(source.doc)}${source.clause != null ? `&clause=${source.clause}` : ""}`;
  return <Link to={`${bp(pid)}/agreements${q}`} className="jump" title={`Open the clause in ${source.title || "the document"}`} data-testid={testid}>{children}</Link>;
}
